import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap, switchMap, of } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UserService } from '../user/user.service';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private userService: UserService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this.userService.user$.pipe(switchMap((user) => {
            return this._navigation.pipe((switchMap((navigation) => {
                navigation.compact = navigation.compact.filter((item) => item.permissions.includes(user.userType));
                navigation.default = navigation.default.filter((item) => item.permissions.includes(user.userType));
                navigation.futuristic = navigation.futuristic.filter((item) => item.permissions.includes(user.userType));
                navigation.horizontal = navigation.horizontal.filter((item) => item.permissions.includes(user.userType));
                navigation.compact.forEach((item) => {
                    if (item.children) {
                        item.children = item.children.filter((item) => item.permissions.includes(user.userType));
                    }
                })
                navigation.default.forEach((item) => {
                    if (item.children) {
                        item.children = item.children.filter((item) => item.permissions.includes(user.userType));
                    }
                })
                navigation.horizontal.forEach((item) => {
                    if (item.children) {
                        item.children = item.children.filter((item) => item.permissions.includes(user.userType));
                    }
                })
                navigation.futuristic.forEach((item) => {
                    if (item.children) {
                        item.children = item.children.filter((item) => item.permissions.includes(user.userType));
                    }
                })

                return of(navigation)
            })))
        }))


        // return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        // return this._httpClient.get<Navigation>('api/common/navigation').pipe(
        //     switchMap((navigation) => {
        //         return this.userService.user$.pipe(switchMap((user) => {
        //             console.log(navigation);

        //             navigation.compact = navigation.compact.filter((item) => item.permissions.includes(user?.userType));
        //             navigation.default = navigation.default.filter((item) => item.permissions.includes(user?.userType));
        //             navigation.futuristic = navigation.futuristic.filter((item) => item.permissions.includes(user?.userType));
        //             navigation.horizontal = navigation.horizontal.filter((item) => item.permissions.includes(user?.userType));
        //             navigation.compact.forEach((item) => {
        //                 if (item.children) {
        //                     item.children = item.children.filter((item) => item.permissions.includes(user?.userType));
        //                 }
        //             })
        //             navigation.default.forEach((item) => {
        //                 if (item.children) {
        //                     item.children = item.children.filter((item) => item.permissions.includes(user?.userType));
        //                 }
        //             })
        //             navigation.horizontal.forEach((item) => {
        //                 if (item.children) {
        //                     item.children = item.children.filter((item) => item.permissions.includes(user?.userType));
        //                 }
        //             })
        //             navigation.futuristic.forEach((item) => {
        //                 if (item.children) {
        //                     item.children = item.children.filter((item) => item.permissions.includes(user?.userType));
        //                 }
        //             })
        //             this._navigation.next(navigation);
        //             // console.log(navigation);

        //             return of(navigation)
        //         })
        //         );
        //     }))

        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) => {
                this._navigation.next(navigation);
            })
        );
    }
}
